var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"f_ocx2"}},[_c('iframe',{attrs:{"name":"myiframe","id":"sharePlayer","src":_vm.cdbm,"frameborder":"0","align":"middle","width":"100%","height":"100%","scrolling":"no","allow":"microphone; camera; display-capture;"}})])}
var staticRenderFns = []

export { render, staticRenderFns }